import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';

/**
 * Returns a string of ids where each id is separated by a space.
 * @param ids - A list of element ids (each id is a parameter).
 * @returns A string of space separated ids, or undefined.
 */
function concatIds() {
  for (var _len = arguments.length, ids = new Array(_len), _key = 0; _key < _len; _key++) {
    ids[_key] = arguments[_key];
  }

  return _filterInstanceProperty(ids).call(ids, function (id) {
    return typeof id === 'string';
  }).join(' ') || undefined;
}

export { concatIds as default };
